import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';
import { ScreenSizes } from '@interfaces';
import { colors } from '@constants/colors';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  const { appTheme } = useMytaverse();
  const subtitleColor = appTheme.loginPage.assets.subtitleColor;

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
    },
    subtitle: (forceKeepSubtitle: boolean) => ({
      fontWeight: 600,
      fontSize: 20,
      lineHeight: '150%',
      color: subtitleColor,
      marginTop: 1,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        display: forceKeepSubtitle ? 'block' : 'none',
        fontSize: '16px',
      },
      [breakpoints.down(ScreenSizes.Tablet)]: {
        display: forceKeepSubtitle ? 'block' : 'none',
        fontSize: '14px',
      },
    }),
    text: (forceKeepSubtitle: boolean) => ({
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '150%',
      color: colors.grey_500,
      marginTop: 1,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        display: forceKeepSubtitle ? 'block' : 'none',
        fontSize: '14px',
      },
      [breakpoints.down(ScreenSizes.Tablet)]: {
        display: forceKeepSubtitle ? 'block' : 'none',
        fontSize: '12px',
      },
    }),
  };
};
